import { inject, Injectable } from '@angular/core';
import { filter, tap } from 'rxjs/operators';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { SpendingInitialCardComponent } from './home-cards/spending-initial-card/spending-initial-card.component';
import { SpendingCompleteCardComponent } from './home-cards/spending-complete-card/spending-complete-card.component';
import { NewSpendingAccountService } from '@brightside-web/desktop/feature/spending-account';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpendingCardService {

  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _spendingSvc: NewSpendingAccountService = inject(NewSpendingAccountService);
  private _sub = new Subscription();

  constructor() {
    this._sub.add(
      this._serviceInventory.getService('spending')
        .pipe(
          filter((service) => !!service),
          tap((service) => {
            switch (service.state) {
              case ServiceState.INITIAL:
                this.registerSpendingInitialCard();
                break;
              case ServiceState.MAINTENANCE:
                break;
              default:
                this.registerSpendingCompleteCard();
                break;
            }
          })
        )
        .subscribe()
    )
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private registerSpendingInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'spending',
      component: 'SpendingInitialCardComponent',
      componentRef: SpendingInitialCardComponent,
      data: null,
      order: 2,
      section: HomeFeedSection.MYMONEYINITIAL
    });
  }

  private registerSpendingCompleteCard() {
    this._spendingSvc.getSpendingAccounts();
    this._homeFeedService.removeHomeFeedCard('spending', HomeFeedSection.MYMONEYINITIAL);
    this._homeFeedService.registerHomeFeedCard({
      key: 'spending',
      component: 'SpendingCompleteCardComponent',
      componentRef: SpendingCompleteCardComponent,
      data: null,
      order: 2,
      section: HomeFeedSection.MYMONEYCOMPLETE
    });
  }
}
